import api from '@/api';
import { API_BASE_URL } from '..';

export default async function commonGenerateReport<P>(URL = '', params?: P) {
  const result = (await api.getReport(API_BASE_URL + URL, params)) as unknown;
  return result as BlobPart;
}
